import EdSplashScreen from './components/ed-splash-screen/ed-splash-screen.component.vue';
import Component from 'vue-class-component';
import Vue from 'vue';
import { SPLASH_SCREEN_EVENTS } from './enum/splash-screen.enum';
import { SplashScreenOptions } from './interfaces/splash-screen.interface';

@Component
export class SplashScreenPlugin extends Vue {

  public spinner = false;
  public message = '';

  show(options?: SplashScreenOptions) {
    if(options) {
      this.spinner = options.spinner || false;
      this.message = options.message || '';
    }
    this.$SplashScreen.$emit(SPLASH_SCREEN_EVENTS.SPLASH_SCREEN_SHOW);
  }

  hide() {
    this.$SplashScreen.$emit(SPLASH_SCREEN_EVENTS.SPLASH_SCREEN_HIDE);
  }

}

export const SplashScreen = {

  install: (Vue) => {

    /* Components */
    Vue.component('ed-splash-screen', EdSplashScreen);

    Vue.prototype.$SplashScreen = new Vue(SplashScreenPlugin);

  }

}